import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=fd6362d6&scoped=true"
import script from "./IconPicker.vue?vue&type=script&lang=js"
export * from "./IconPicker.vue?vue&type=script&lang=js"
import style0 from "./IconPicker.vue?vue&type=style&index=0&id=fd6362d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6362d6",
  null
  
)

export default component.exports